// extracted by mini-css-extract-plugin
module.exports = {"container":"Files_container__2_-z4","hidden":"Files_hidden__1N73F"};